import React, { ReactNode, SetStateAction } from "react";

import ResetButton from '../../../../common/filterTable/components/Buttons/ResetButton';
import SearchButton from '../../../../common/filterTable/components/Buttons/SearchButton';
import Filters from '../../../../common/filterTable/components/Filters/Filters';
import FilterActions from '../../../../common/filterTable/layout/FilterActions';
import FilterGrid from '../../../../common/filterTable/layout/FilterGrid';
import { useGenFilterField } from '../../../../utils/ComponentHelper';
import { FilterFields, FilterFieldsKeys } from '../types/FilterFields';
import AgentProgramNameSelection from '../../../../components/AgentProgramNameSelection';
import OrderIdTextField from "../../../../common/filterTable/components/Filters/OrderIdTextField";
import PFHNumberTextField from "../../../../common/filterTable/components/Filters/PFHNumberTextField";
import OriginalCardNumberTextField from "../../../../common/filterTable/components/Filters/OriginalCardNumberTextField";
import PanLast4TextField from "../../../../common/filterTable/components/Filters/PanLast4TextField";
import E6CardStatusSingleSelection from "../../../../common/filterTable/components/Filters/E6CardStatusSingleSelection";
import DistributorAgentIdTextField from "../../../../common/filterTable/components/Filters/DistributorAgentIdTextField";
import StatusSingleSelection from "../../../../common/filterTable/components/Filters/StatusSingleSelection";
import CardNumberTextField from "../../../../common/filterTable/components/Filters/CardNumberTextField";
import CardProfileNameTextField from "../../../../common/filterTable/components/Filters/CardProfileNameTextField";
import ReissuedOrderIdTextField from "../../../../common/filterTable/components/Filters/ReissueOrderIdTextField";
import DistributorAgentIdAutoComplete from "../../../../common/filterTable/components/Filters/DistributorAgentIdAutoComplete";
import { PartialSearchDistributorAgentIdResponse } from "../../../../api/types";
import APIs from "../../../../api";

interface FilterSectionProps {
  fields: FilterFields;
  setFields: React.Dispatch<SetStateAction<FilterFields>>;
  onSearch: () => void;
  onReset: () => void;
  DateObj: any;
  profile: any;
}

const FilterSection = (props: FilterSectionProps) => {
  const { fields, setFields, onSearch, onReset, DateObj, profile } = props;
  const updateField = (fieldName: string, value: any) => {
    setFields((fields) => {
      return {
        ...fields,
        [fieldName]: value,
      };
    });
  };
  const [distributorAgentIdOptions, setDistributorAgentIdOptions] = React.useState<
    PartialSearchDistributorAgentIdResponse[]
  >([]);

  const handleDistributorAgentIdInputChange = async (value: string) => {
    setFields((fields) => ({ ...fields, distributorAgentId: value }));

    if (value) {
      const res = await APIs.setting.userSetting.partialSearchDistributorAgentId({
        keywords: value.toUpperCase(),
        limit: 10,
        offset: 0,
      });

      if (!res) return;

      setDistributorAgentIdOptions(res);
    }
  };

  const handleDistributorAgentIdOptionChange = (value: string) => {
    setFields((fields) => ({ ...fields, distributorAgentId: value }));
  };

  const filterFields: ReactNode[] = useGenFilterField([
    ['creationTime', <DateObj.CreationTime.Picker type="dateTime" />],
    ['lastModifiedTime', <DateObj.LastModifiedTime.Picker type="dateTime" />],
    [
      FilterFieldsKeys.programName,
      <AgentProgramNameSelection
        mode={'assignableOnly'}
        distributorAgentId={profile?.jwtDetails?.programAgentId}
        value={fields[FilterFieldsKeys.programName]}
        onChange={(e) => updateField(FilterFieldsKeys.programName, e.target.value)}
        clearSelect={() => updateField(FilterFieldsKeys.programName, '')}
      />,
    ],
    [
      FilterFieldsKeys.cardProfileName,
      <CardProfileNameTextField
        value={fields[FilterFieldsKeys.cardProfileName]}
        onChange={(e) => updateField(FilterFieldsKeys.cardProfileName, e.target.value)}
      />
    ],
    [
      FilterFieldsKeys.orderId,
      <OrderIdTextField
        value={fields[FilterFieldsKeys.orderId]}
        onChange={(e) => updateField(FilterFieldsKeys.orderId, e.target.value)}
      />,
    ],
    [
      FilterFieldsKeys.pfhNumber,
      <PFHNumberTextField
        value={fields[FilterFieldsKeys.pfhNumber]}
        onChange={(e) => updateField(FilterFieldsKeys.pfhNumber, e.target.value)}
      />,
    ],
    [
      FilterFieldsKeys.originalCardNumber,
      <OriginalCardNumberTextField
        value={fields[FilterFieldsKeys.originalCardNumber]}
        onChange={(e) => updateField(FilterFieldsKeys.originalCardNumber, e.target.value)}
      />,
    ],
    [
      FilterFieldsKeys.cardNumber,
      <CardNumberTextField
        value={fields[FilterFieldsKeys.cardNumber]}
        onChange={(e) => updateField(FilterFieldsKeys.cardNumber, e.target.value)}
      />,
    ],
    [
      FilterFieldsKeys.panLast4,
      <PanLast4TextField
        value={fields[FilterFieldsKeys.panLast4]}
        onChange={(e) => updateField(FilterFieldsKeys.panLast4, e.target.value)}
      />,
    ],
    [
      FilterFieldsKeys.status,
      <StatusSingleSelection
        value={fields[FilterFieldsKeys.status]}
        onChange={(e) => updateField(FilterFieldsKeys.status, e.target.value)}
        onClear={() => updateField(FilterFieldsKeys.status, '')}
      />
    ],
    [
      FilterFieldsKeys.reissuedOrderId,
      <ReissuedOrderIdTextField
        value={fields[FilterFieldsKeys.reissuedOrderId]}
        onChange={(e) => updateField(FilterFieldsKeys.reissuedOrderId, e.target.value)}
      />,
    ],  
    [
      FilterFieldsKeys.e6CardStatus,
      <E6CardStatusSingleSelection
        value={fields[FilterFieldsKeys.e6CardStatus]}
        onChange={(e) => updateField(FilterFieldsKeys.e6CardStatus, e.target.value)}
        onClear={() => updateField(FilterFieldsKeys.e6CardStatus, '')}
      />
    ],
    [
      FilterFieldsKeys.distributorAgentId,
      <DistributorAgentIdAutoComplete
        value={fields.distributorAgentId}
        options={distributorAgentIdOptions}
        onInputChange={(value: string) => {
          handleDistributorAgentIdInputChange(value);
        }}
        handleChange={(option: PartialSearchDistributorAgentIdResponse) => {
          handleDistributorAgentIdOptionChange(option?.distributorAgentId);
        }}
        setOptions={setDistributorAgentIdOptions}
      />
    ]


  ]);

  return (
    <>
      <FilterGrid>
        <Filters filterFields={filterFields} />
      </FilterGrid>
      <FilterActions>
        <SearchButton onSearch={onSearch} />
        <ResetButton onReset={onReset} />
      </FilterActions>
    </>
  );
};

export default FilterSection;